import Icon from "../atoms/Icon";
import { Label } from "../atoms/Label";

type ActionButtonProps = {
	iconName: string;
	label: string;
	href?: string;
	target?: string;
	onclick?: () => void;
	className?: string;
};

export default function ActionButton({
	iconName,
	label,
	href, 
	target,
	onclick,
	className,
}: ActionButtonProps) {
	return (
		<a className={["flex flex-col items-center gap-1 lg:gap-2 transition delay-150 duration-300 cursor-pointer ease-in-out hover:-translate-y-1 hover:scale-110", className ?? ""].join(" ")} target={target} href={href} title="" onClick={onclick}>
			<div className="bg-secondary rounded-full p-3 lg:p-4">
				<Icon src={iconName} size={30} alt="" className="" />
			</div>
			<div className="bg-secondary text-white text-xs font-bold px-4 lg:py-[6px] py-0 rounded-full uppercase">
				<Label text={label} htmlFor={""} />
			</div>
		</a>
	);
}
